<template>
    <div class="pb-4">
        <template v-if="formresponse_data">
            <div class="float-right">
                <button class="btn btn-secondary mb-2 ml-2" title="Download" @click="download"><b-icon-download /></button>
                <button 
                        v-if="showUnreviewBtn" 
                        class="btn btn-outline-danger mb-2 ml-2" 
                        @click="unreview"
                >
                    {{ $t('remove-review') }}
                </button>
                <template v-if="!requestSignoffActive">
                    <template v-if="!isSignedOff">
                        <b-dropdown id="dropdown-1" :text="currentStatusText" class="mb-2 ml-2"
                            :variant="formresponse.formresponse_abandoned != 1 ? 'primary' : ''">
                            <b-dropdown-item v-if="formresponse.formresponse_abandoned != 1" @click="openDialog('abandon')">{{ $t('abandon') }}</b-dropdown-item>
                            <b-dropdown-item v-if="formresponse.formresponse_abandoned == 1" @click="openDialog('activate')">{{ $t('activate') }}</b-dropdown-item>
                            <b-dropdown-item @click="openDialog('delete')">{{ $t('delete') }}</b-dropdown-item>
                        </b-dropdown>

                        <button class="btn btn-secondary mb-2 ml-2" v-if="showWithdrawBtn"
                            @click="withdrawFormResponse()">
                            {{ showIncompleteLabel ? $t('incomplete') : $t('withdraw') }}
                        </button>
                        <button class="btn btn-outline-secondary mb-2 ml-2" @click="saveFormResponse(false)"
                            v-if="showSaveDraftBtn">
                            <template v-if="(showCompleteBtn || showSignOffBtn)">
                                {{ $t('save-draft') }}
                            </template>
                            <template v-else>
                                {{ $t('save') }}
                            </template>
                        </button>
                        <button class="btn btn-success mb-2 ml-2" v-if="showCompleteBtn"
                            @click="formresponse.formresponse_completed = 1; saveFormResponse()"
                            :disabled="!requiredFieldsCompletedFor('submitter')">{{ $t('submit-form') }}</button>
                        <button
                            class="btn btn-outline-success mb-2 ml-2"
                            v-if="showMarkAsCompleteBtn"
                            @click="formresponse.formresponse_completed = 1; saveFormResponse()"
                        >
                            {{ $t('mark-as-complete') }}</button>
                        <button class="btn btn-success mb-2 ml-2" v-if="showSignOffBtn"
                            @click="formresponse.formresponse_signedoff = 1; saveFormResponse()"
                            :disabled="!requiredFieldsCompletedFor('signer')">
                            {{ $t('sign-off') }}</button>
                        <button class="btn btn-success mb-2 ml-2" v-if="showReviewBtn"
                            @click="formresponse.formresponse_reviewed = 1; saveFormResponse()"
                            :disabled="!requiredFieldsCompletedFor('reviewer')">{{ $t('submit-review') }}</button>
                    </template>
                    <template v-else>
                        <button class="btn btn-outline-secondary mb-2 ml-2" @click="saveFormResponse(false)">
                            {{ $t('save') }}
                        </button>
                        <button class="btn btn-danger mb-2 ml-2" v-if="showUnsignBtn" @click="unsign">{{ $t('remove-sign-off') }}</button>
                    </template>
                </template>
                <button class="btn btn-success mb-2 ml-2" v-if="showObserveBtn"
                    @click="formresponse.formresponse_observed = 1; saveFormResponse()">
                    {{ $t('mark-as-observed') }}</button>
            </div>
            <template v-if="formresponse.savedreport">
                <Avatar class="avatar d-inline-block align-top mr-4 mb-3 lg:mb-0"
                    :userId="formresponse.savedreport.student_id" v-if="isTeacher" />
            </template>
            <template v-else>
                <Avatar class="avatar d-inline-block align-top mr-4 mb-3 lg:mb-0" :userId="formresponse.user_id"
                    v-if="isTeacher" />
            </template>
            <div class="clearfix d-inline-block align-top">
                <h2 class="mb-0">
                    <template v-if="formresponse.savedreport">
                        {{ $t('report-for') }} {{ formresponse.savedreport.student_displayname }}
                    </template>
                    <template v-else-if="formresponse_data.title">
                        {{ formresponse_data.title }}
                    </template>
                    <span v-if="(formresponse.formresponse_abandoned == '1')" class="badge badge-secondary">{{
                        $t('abandoned') }}</span>
                </h2>
                <p class="mb-4">
                    <template v-if="formresponse.savedreport">
                        {{ formresponse.savedreport.inputs.savedreport_title }}
                    </template>
                    <template v-if="formresponse.user_id != $UserSession.getValue('id')">
                        {{ $t('user-colon') }} <strong>{{ formresponse.user_displayname }}</strong>
                        <template v-if="formresponse.usersignoff_displayname">
                            <br>
                        </template>
                    </template>
                </p>
            </div>
            <div>
                <template v-if="formresponse.savedreport">
                    {{ $t('programme-colon') }} {{ $config.getProgrammeNameById(formresponse.savedreport.inputs.programme) }} |
                    {{ $t('year') }} {{ formresponse.savedreport.inputs.year }} |
                    {{ $t('term') }} {{ $config.getTermNameById(formresponse.savedreport.inputs.term) }}<br>
                    {{ $config.getSpecialtyNameById(formresponse.savedreport.inputs.specialty) }} |
                    {{ $datetime.getLocaleStringFromISODate(formresponse.savedreport.inputs.date_from) }} -
                    {{ $datetime.getLocaleStringFromISODate(formresponse.savedreport.inputs.date_to) }}
                </template>
                <template v-if="formresponse.userreview_displayname">
                    <p class="mb-2">
                        <template v-if="(formresponse.formresponse_reviewed == '1')">
                            <span class="badge badge-pill badge-success">
                                {{ $t('reviewed-by') }}
                                <strong>{{ formresponse.userreview_displayname }}</strong>
                            </span>
                        </template>
                        <template v-else>
                            {{ $t('review-colon') }} <strong>{{ formresponse.userreview_displayname }}</strong>
                        </template>
                        <button class="btn btn-outline-dark btn-sm ml-2" @click="selectReviewer()"
                            v-if="!isReviewed && reviewers.length">{{ $t('change') }}</button>
                    </p>
                </template>

                <template v-if="formresponse.usersignoff_displayname || formresponse.externaluser_id">
                    <p class="mb-2">
                        <template v-if="(formresponse.formresponse_signedoff == '1')">
                            <span class="badge badge-pill badge-success">
                                {{ $t('signed-off-by') }}
                                <strong>
                                	<template v-if="formresponse.externaluser">
                                		{{formresponse.externaluser.externaluser_name}}
                                		({{$t('external-user')}})
                                	</template>
                                	<template v-else-if="formresponse.usersignoff_displayname">
                               			{{formresponse.usersignoff_displayname}}
                                	</template>
                               </strong>
                            </span>
                        </template>
                        <template v-else>
                        	{{ $t('signoff-colon') }}
                        	<strong>
								<template v-if="formresponse.externaluser">
									{{formresponse.externaluser.externaluser_name}}
									({{$t('external-user')}})
								</template>
								<template v-else-if="formresponse.usersignoff_displayname">
									{{formresponse.usersignoff_displayname}}
								</template>
                            </strong>
                        </template>
                        <button class="btn btn-outline-dark btn-sm ml-2" @click="selectSigner()"
                            v-if="!isSignedOff && signers.length">{{ $t('change') }}</button>
                    </p>
                </template>
                <template v-if="formresponse.userobserver_displayname">
                    <p class="mb-2">
                        {{ $t('observer-colon') }} <strong>{{ formresponse.userobserver_displayname }}</strong>
                        <button class="btn btn-outline-dark btn-sm ml-2" @click="selectObserver()"
                            v-if="showObserver && observers.length">{{ $t('change') }}</button>
                    </p>
                </template>
                <template v-if="awaitingFeedbackFromDisplayName">
                    <p class="text-subtle mb-2">{{ $t('awaiting-feedback-from-colon') }} <strong>{{
                        awaitingFeedbackFromDisplayName }}</strong></p>
                </template>
            </div>

            <template v-if="role != 'submitter'">
            	<div v-if="formresponse.created">
            		{{ $t('created-colon') }}
            		{{ $datetime.getLocaleStringFromTimeStamp(formresponse.created, false) }}
            	</div>
                <div v-if="formresponse.formresponse_completed != '1'" class="alert alert-info">
                    {{ $t('awaiting-completion') }}</div>
                <div v-else-if="formresponse.userreview_id && formresponse.formresponse_reviewed != '1'"
                    class="alert alert-info">{{ $t('awaiting-review') }}</div>
                <div v-else-if="(formresponse.usersignofffrom_id || formresponse.externaluser_id) && formresponse.formresponse_signedoff != '1'"
                    class="alert alert-info">{{ $t('awaiting-signoff') }}</div>

				<div class="list-group mb-3" v-if="formresponse.externaluser_id">
					<div class="list-group-item">
						<strong>{{ $t('external-user-details') }}</strong>
					</div>
					<div class="list-group-item">
						<div class="row">
							<div class="col-md-6 col-lg-3">
								<strong>{{$t('name-colon') }} </strong>{{ formresponse.externaluser.externaluser_name }}
							</div>
							<div class="col-md-6 col-lg-3">
								<strong>{{$t('email-colon') }} </strong>{{ formresponse.externaluser.externaluser_email }}
							</div>
							<div class="col-md-6 col-lg-3">
								<strong>{{$t('phone-colon') }} </strong>{{ formresponse.externaluser.externaluser_phone }}
							</div>
							<div class="col-md-6 col-lg-3">
								<strong>{{$t('registration-number-colon') }} </strong>{{ formresponse.externaluser.externaluser_regno }}
							</div>
						</div>
					</div>
				</div>
            </template>

            <p v-if="formresponse.formresponse_message" style="white-space: pre-wrap" class="mt-0 mb-4">
                {{ formresponse.formresponse_message }}
            </p>

            <div v-if="showSubject" class="clearfix mb-3">
                <div class="card">
                    <h5 class="card-header">{{ $t('subject') }}</h5>
                    <div class="card-body">
                        <SelectSearchInput :label="$t('subject')" v-model="formresponse.usersubject_id"
                            :options="this.subjects" optionValue="id" optionLabel="displayname" @click="alert('here');" />
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-3">
                    <div class="form-group">
                        <label>{{ $t("date-time") }}</label>
                        <input type="datetime-local" v-model="formresponse.datetime" class="form-control"
                            :disabled="isSignedOff" />
                    </div>
                </div>

                <div class="col-md-6" v-if="$config.getValue('workbooks').length>0">
                    <div class="form-group">
                        <label for="form">{{ $t('workbooks') }}</label>
                        <div class="clearfix">
                            <div class="pseudo-input mb-4">
                                <input type="search" class="input-bare w-full flex-1" :placeholder="$t('workbooks')"
                                    v-if="!formresponse.workbooks.length" @click="openWorkbooksModal" />
                                <span class="badge badge-secondary badge-sm mr-2 mb-2"
                                    v-for="(workbook, index) in formresponse.workbooks" v-bind:key="index">
                                    {{ workbook.title }}
                                    <a @click="removeWorkbook(workbook)"><b-icon icon="x"></b-icon></a>
                                </span>
                                <span class="badge badge-primary badge-sm mr-2 mb-2" v-if="formresponse.workbooks.length"
                                    @click="openWorkbooksModal">
                                    <b-icon icon="plus"></b-icon> {{ $t('add') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <EventSelector v-if="formresponse.workflowstage
                && (Number(formresponse.workflowstage.updateattendance) == 1 || Number(formresponse.workflowstage.updateabsence) == 1)"
                :events="formresponse.ttevents || []"
                :ttevents="ttevents"
                :canEdit="Number(formresponse.formresponse_completed) !== 1"
                :multipleSelect="Number(formresponse.workflowstage.allowmultipleevents) === 1"
                @ttevent_ids="handleEventSelector"
            />

			<div class="card mb-4" v-if="formresponse_data.showProgress && formresponse_data.showProgress == true">
				<div class="card-body">
                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <div class="header-stats">
                                <div class="stat">
                                    <span class="stat-label">{{ $t('progess') }}</span>
                                    <span class="stat-value">{{ completionStats.percentage }}%</span>
                                </div>
                                <div class="stat">
                                    <span class="stat-label">{{ $t('graded') }}</span>
                                    <span class="stat-value">{{ completionStats.graded }}/{{ completionStats.total }}</span>
                                </div>
                                <!--
                                <div class="stat">
                                    <span class="stat-label">Score</span>
                                    <span class="stat-value">{{ completionStats.totalScore }}/{{ completionStats.maxPossibleScore }}</span>
                                </div>
                                -->
                            </div>
                        </div>
                        <div class="col-12 col-lg-6" style="text-align: right">
                            <div class="btn-group mt-2">
                                <button :class="!showOnlyEmpty ? 'btn btn-primary' : 'btn btn-secondary'" @click="showOnlyEmpty = false">{{ $t('all') }}</button>
                                <button :class="showOnlyEmpty ? 'btn btn-primary' : 'btn btn-secondary'" @click="showOnlyEmpty = true">{{ $t('unanswered') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
			</div>

            <template v-if="(formresponse_data.navigation == 'sidebar')">
                <TabbedView @done="saveFormResponse" @hasNextChanged="hasNextUpdater">
                    <TabbedViewTab v-for="(page, pageIndex) in filteredPages" :title="page.title" :id="pageIndex.toString()"
                        :key="pageIndex">
                        <FormGrid :page="page" :formresponse="formresponse"
                            :readonly="!canEdit || !userCanCompletePage(page)" :viewAs="role"
                            @limit-exceeded="validateCounts"
                            ></FormGrid>
                    </TabbedViewTab>
                </TabbedView>
            </template>
            <template v-else>
                <template v-for="(page, pageIndex) in filteredPages">
					<template v-if="pageNum === (pageIndex + 1) || formresponse_data.navigation === 'singlepage'">
                        <FormGrid
                            :key="pageIndex"
                            :page="page"
                            :formresponse="formresponse"
                            :readonly="!canEdit || !userCanCompletePage(page)" 
                            :viewAs="role"
                            :showOnlyEmpty="showOnlyEmpty"
                            :pageStats="getPageStats(page)"
                            @limit-exceeded="validateCounts"
					    ></FormGrid>
                    </template>
                </template>
                <div class="clearfix mb-3">
                    <button class="btn btn-secondary" v-if="showPreviousPageBtn" @click="previousPage">{{
                        $t('previous-page') }}</button>
                    <button class="btn btn-primary ml-2" v-if="showNextPageBtn" @click="nextPage">{{ $t('next-page')
                    }}</button>
                </div>
            </template>

            <div v-if="showReviewer" class="clearfix mb-3">
                <div class="card">
                    <h5 class="card-header">{{ $t('reviewer') }}</h5>
                    <div class="card-body">
                        <SelectSearchInput :label="$t('reviewer')" v-model="formresponse.userreview_id"
                            :options="this.reviewers" optionValue="id" optionLabel="displayname" />
                    </div>
                </div>
            </div>

            <div v-if="showObserver" class="clearfix mb-3">
                <div class="card">
                    <h5 class="card-header">{{ $t('observer') }}</h5>
                    <div class="card-body">
                        <p v-if="observersAdhoc" class="form-control-plaintext">
                            {{ observers.map(u => u.displayname).join(', ') }}
                        </p>
                        <SelectSearchInput v-else :label="$t('observer')" v-model="formresponse.userobserver_id"
                            :options="this.observers" optionValue="id" optionLabel="displayname" />
                    </div>
                </div>
            </div>

            <LearningOutcomesMapper v-if="canEditLearningOutcomes" v-model="formresponse.learningoutcomes" class="mb-3">
                <template v-slot:label>
                    <h2>{{ $t('learning-outcomes') }}</h2>
                </template>
            </LearningOutcomesMapper>

            <div class="clearfix mb-3" v-if="!requestSignoffActive">
                <div class="float-right">
                    <template v-if="!isSignedOff">
                        <!--button class="btn btn-secondary mb-2 ml-2" @click="abandon" v-if="showAbandonBtn">{{ $t('abandon')
                        }}</button-->
                        <button class="btn btn-secondary mb-2 ml-2" v-if="showWithdrawBtn"
                            @click="withdrawFormResponse()">
                            {{ showIncompleteLabel ? $t('incomplete') : $t('withdraw') }}
                        </button>
                        <button class="btn btn-outline-secondary mb-2 ml-2" @click="saveFormResponse(false)"
                            v-if="showSaveDraftBtn">
                            <template v-if="(showCompleteBtn || showSignOffBtn)">
                                {{ $t('save-draft') }}
                            </template>
                            <template v-else>
                                {{ $t('save') }}
                            </template>
                        </button>
                        <button class="btn btn-success mb-2 ml-2" v-if="showReviewBtn"
                            @click="formresponse.formresponse_reviewed = 1; saveFormResponse()"
                            :disabled="!requiredFieldsCompletedFor('reviewer')"
                        >
                            {{ $t('submit-review') }}
                        </button>
                        <button class="btn btn-primary mb-2 ml-2"
                            v-if="showRequestSignOffBtn"
                            @click="requestSignoffActive = true"
                            :disabled="!requiredFieldsCompletedFor('submitter')"
                        >
                            {{ formresponse.formresponse_completed==1
                                ? $t('change-signoff')
                                : $t('request-signoff') }}
                        </button>
                        <button class="btn btn-success mb-2 ml-2" v-if="showCompleteBtn"
                            @click="formresponse.formresponse_completed = 1; saveFormResponse()"
                            :disabled="!requiredFieldsCompletedFor('submitter')"
                            >{{ $t('submit-form') }}</button>
                      <button
                            class="btn btn-outline-success mb-2 ml-2"
                            v-if="showMarkAsCompleteBtn"
                            @click="formresponse.formresponse_completed = 1; saveFormResponse()"
                        >
                            {{ $t('mark-as-complete') }}</button>
                        <button class="btn btn-success mb-2 ml-2" v-if="showSignOffBtn"
                            @click="formresponse.formresponse_signedoff = 1; saveFormResponse()"
                            :disabled="!requiredFieldsCompletedFor('signer')">{{ $t('sign-off') }}</button>
                    </template>
                    <template v-else>
                        <button class="btn btn-outline-secondary mb-2 ml-2" @click="saveFormResponse(false)">
                            {{ $t('save') }}
                        </button>
                        <button class="btn btn-danger mb-2 ml-2" v-if="showUnsignBtn" @click="unsign">{{ $t('remove-sign-off') }}</button>
                    </template>
                    <button class="btn btn-success mb-2 ml-2" v-if="showObserveBtn"
                        @click="formresponse.formresponse_observed = 1; saveFormResponse()">
                        {{ $t('mark-as-observed') }}</button>
                </div>
            </div>

            <div class="row" v-if="requestSignoffActive">
                <div class="col-md-12" ref="requestSignoff">
                    <div class="float-right">
                        <button class="btn btn-secondary ml-2" @click="requestSignoffActive = false">{{ $t('cancel') }}</button>
                    </div>
                    <h2>{{ formresponse.formresponse_completed
                        ? $t('change-signoff')
                        : $t('request-signoff') }}</h2>
                    <b-tabs pills v-model="tabIndex" content-class="mb-4 pt-2">
                        <b-tab v-if="formresponse.workflowstage">
                            <template #title>
                                {{ $t('signer') }}
                            </template>
                            <div class="card">
                                <h5 class="card-header">{{ $t('signer') }}</h5>
                                <div class="card-body">
                                    
                                    <SelectSearchInput :label="$t('signer')" v-model="formresponse.usersignofffrom_id"
                                        :options="signers" optionValue="id" optionLabel="displayname"
                                        @click="selectSigner()" />
                                    <button class="btn btn-primary mb-2 ml-2 float-right"
                                        v-if="formresponse.usersignofffrom_id" @click="handleSignoffBtn()"
                                        :disabled="!requiredFieldsCompletedFor('submitter')">{{ $t('request-signoff') }}</button>
                                </div>
                            </div>
                        </b-tab>

                        <b-tab
                            v-if="formresponse.workflowstage && Number(formresponse.workflowstage.allowanonymoussignoff) == 1"
                            lazy>
                            <template #title>
                                {{ $t('external-user') }}
                            </template>
                            <ExternalUser :formresponse="formresponse" :ttevent_id="ttevent_id" @external-user-saved="fetchExtUser" />
                        </b-tab>
                    </b-tabs>
                </div>
            </div>

        </template>



        <template v-if="reportHtml">
            <b-tabs pills v-model="currentreporttab">
                <b-tab :title="$t('term-report')">
                    <b-card-text>
                        <div class="mt-3" v-html="reportHtml"></div>
                        <div class="mt-3" v-if="loadingreportview">
                            <div class="clearfix">
                                <div class="skeleton midnight h100 w100 mr-4 mb-3 float-left"></div>
                                <div class="skeleton midnight h100 w100 mr-4 mb-3 float-left"></div>
                                <div class="skeleton midnight h100 w100 mr-4 mb-3 float-left"></div>
                            </div>
                            <div class="skeleton midnight h32 mb-3"></div>
                            <div class="skeleton midnight h32 mb-3"></div>
                            <div class="skeleton midnight h32 mb-3"></div>
                            <div class="skeleton midnight h32 mb-3"></div>
                            <div class="skeleton midnight h32 mb-3"></div>
                        </div>
                    </b-card-text>
                </b-tab>
                <b-tab v-if="$config.hasModule('clinical')" :title="$t('activity-report')">
                    <b-card-text>
                        <a class="btn btn-outline-secondary btn-sm mt-3"
                            :href="`/report/htmlreport/individual/${this.formresponse.savedreport.student_id}?date_from=${this.formresponse.savedreport.inputs.date_from}&amp;date_to=${this.formresponse.savedreport.inputs.date_to}&amp;teacher=${this.$UserSession.getValue.call(this, 'id')}`"
                            target="_blank">
                            {{ $t('open-in-new-window') }}
                        </a>
                        <div class="mt-3" v-html="individualReportHtml"></div>
                        <div class="mt-3" v-if="loadinghtmlreportview">
                            <div class="clearfix">
                                <div class="skeleton midnight h100 w100 mr-4 mb-3 float-left"></div>
                                <div class="skeleton midnight h100 w100 mr-4 mb-3 float-left"></div>
                                <div class="skeleton midnight h100 w100 mr-4 mb-3 float-left"></div>
                            </div>
                            <div class="skeleton midnight h32 mb-3"></div>
                            <div class="skeleton midnight h32 mb-3"></div>
                            <div class="skeleton midnight h32 mb-3"></div>
                            <div class="skeleton midnight h32 mb-3"></div>
                            <div class="skeleton midnight h32 mb-3"></div>
                        </div>
                    </b-card-text>
                </b-tab>
            </b-tabs>
        </template>

    </div>
</template>

<script>
import Avatar from "src/components/Avatar.vue";
import TabbedView from "src/components/TabbedView";
import TabbedViewTab from "src/components/TabbedViewTab";
import FormGrid from "src/components/FormEditor/FormGrid";
import ExternalUser from "src/components/ExternalUser";
import LearningOutcomesMapper from "src/components/LearningOutcomes/LearningOutcomesMapper";
import EventSelector from "../../components/Events/EventSelector.vue";

export default {
    components: {
        Avatar,
        TabbedView,
        TabbedViewTab,
        FormGrid,
        ExternalUser,
        LearningOutcomesMapper,
        EventSelector
    },
    data: function () {
        return {
        	showOnlyEmpty: false,
            formid: null,
            formresponse: {
                id: null,
                workflowstage_id: null,
                learningoutcomes: [],
                user_id: null,
                userfrom_id: null,
                usersubject_id: null,
                userreview_id: null,
                usersignofffrom_id: null,
                userobserver_id: null,
                formresponse_observed: null,
                externaluser_id: null,
                ttevent_id:null,
                ttevent_ids:[],
                datetime: null,
                workbooks: [],
                workflowstage: {},
                formresponse_data: null,
                showProgress: false
            },
            stage: null,
            pageNum: 1,

        	completionStats: {
        		percentage: 0 ,
				graded: 0 ,
				total: 0 ,
				totalScore: 0 ,
				maxPossibleScore: 0
			},
            currentFilter: 'all',

            loadingreportview: true,
            reportHtml: null,
            loadinghtmlreportview: true,
            individualReportHtml: null,
            currentreporttab: 0,
            subjects: [],
            reviewers: [],
            signers: [],
            observers: [],
            observersAdhoc: false,
            viewAs: [],
            hasNext: false,
            requestSignoffActive: false,
            tabIndex: 0,
            externaluser: {},
            ttevents:[],
            ttevent_id: null,
            ttevent_ids: [],
            formsubmissioneventismandatory: false,
            limitexceeded: false
        }
    },
    methods: {
    
    	updateFormProgress() {
    		let total = 0, graded = 0;
    		if (this.formresponse_data) {
    			for (const page of this.formresponse_data.pages) {
    				if (!page.grid) continue;
    				for (const row of page.grid) {
    					for (const col of row) {
    						if (!col.fields) continue;
    						for (const fieldId in col.fields) {
    							const field = col.fields[fieldId];
    							if (!('conditional' in field) || !field.conditional) {
    								if (field.type === 'select' || field.type === 'text' || field.type === 'textarea' || field.type === 'date' || field.type === 'html' || field.type === 'grade' || field.type === 'mark') {
    									total++;
    									if (field.value !== null && field.value !== undefined && field.value !== '') graded++;
    								}
    							}
    						}
    					}
    				}
    			}
    		}
    		this.completionStats.total = total;
    		this.completionStats.graded = graded;
    		this.completionStats.percentage = total > 0 ? Math.round((graded / total) * 100) : 0;
    	},
    	pageHasUnansweredFields(page) {
    		if (!page.grid) return false;
    		for (const row of page.grid) {
    			for (const col of row) {
    				const fields = Array.isArray(col.fields) ? col.fields : Object.values(col.fields || {});
    				for (const field of fields) {
    					if (field.value === null || field.value === '' || field.value === undefined) return true;
    				}
    			}
    		}
    		return false;
    	},
    	getPageStats(page) {
    		let total = 0, graded = 0;
    		if (!page.grid) return { total: 0, graded: 0, percentage: 0 };
    		for (const row of page.grid) {
    			for (const col of row) {
    				if (!col.fields) continue;
    				for (const fieldId in col.fields) {
    					const field = col.fields[fieldId];
    					if (!('conditional' in field) || !field.conditional) {
    						if (field.type === 'select' || field.type === 'text' || field.type === 'textarea' || field.type === 'date' || field.type === 'html' || field.type === 'grade' || field.type === 'mark') {
    							total++;
    							if (field.value !== null && field.value !== undefined && field.value !== '') graded++;
    						}
    					}
    				}
    			}
    		}
    		return { total, graded, percentage: total > 0 ? Math.round((graded / total) * 100) : 0 };
    	},

        abandon() {
            this.$store.commit("openDialog", {
                cancelBtn: true,
                title: this.$t('abandon-form'),
                content: this.$t('are-you-sure-abandon-form'),
                confirmCallBack: () => {
                    this.formresponse.formresponse_abandoned = '1';
                    this.saveFormResponse();
                }
            });
        },
        download() {
            const url = `${this.$settings.APIBaseURL}/forms/response/pdf/${this.$route.params.formresponseid}?username=${this.$UserSession.getValue.call(this, "username")}&authToken=${this.$UserSession.getValue.call(this, "authToken")}`;
            window.open(url);
        },
        getSigners() {

            return this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/selectformroleuser/signoff`, {
                data: {
                    form_id: this.formresponse.form_id,
                    workflowstage_id: this.formresponse.workflowstage_id
                }
            })
                .then((json) => {
                    if (json.status == 'SUCCESS') {
                        this.signers = json.users

                        if(this.signers.length == 1 && !this.formresponse.usersignofffrom_id){
                            this.formresponse.usersignofffrom_id = this.signers[0].id;
                            this.formresponse.usersignoff_displayname = this.signers[0].displayname;
                        }

                    }
                })
                .catch((error) => {
                    this.$log.error.call(this, error);
                });

        },
        handleSignoffBtn(){
            this.formresponse.formresponse_completed = 1;
            this.formresponse.externaluser_id = null;
            if(!this.ttevent_id && Number(this.formresponse.workflowstage.updateattendance) == 1){
                this.noEventWarning();
                return;
            } else {
                this.saveFormResponse();
            }
            
        },
        noEventWarning() {
            const self = this;
            const mandatory = Number(this.formresponse.workflowstage.tteventmandatory) == 1
            this.$store.commit("openDialog", {
                cancelBtn: mandatory ? false : true,
                title: this.$t("no-event"),
                content: mandatory ? this.$t("no-event-message-mandatory") : this.$t("no-event-message"),
                confirmCallBack: function () {
                    if(mandatory) return ;
                    self.saveFormResponse();
                }
            });
        },
        getSubjects() {
            return this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/selectformroleuser/subject`, {
                data: {
                    form_id: this.formresponse.form_id,
                    workflowstage_id: this.formresponse.workflowstage_id
                }
            })
                .then((json) => {
                    if (json.status == 'SUCCESS') {
                        this.subjects = json.users;
                    }
                })
                .catch((error) => {
                    this.$log.error.call(this, error);
                });
        },
        getObservers() {
            return this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/selectformroleuser/observer`, {
                data: {
                    form_id: this.formresponse.form_id,
                    workflowstage_id: this.formresponse.workflowstage_id
                }
            })
                .then((json) => {
                    if (json.status == 'SUCCESS') {
                        this.observers = json.users;
                        this.observersAdhoc = json.adhoc || false;
                        if(this.observers.length == 1 && !this.formresponse.userobserver_id){
                            this.formresponse.userobserver_id = this.observers[0].id;
                            this.formresponse.userobserver_displayname = this.observers[0].displayname;
                        }
                    }
                })
                .catch((error) => {
                    this.$log.error.call(this, error);
                });
        },
        getReviewers() {
            return this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/selectformroleuser/review`, {
                data: {
                    form_id: this.formresponse.form_id,
                    workflowstage_id: this.formresponse.workflowstage_id
                }
            })
                .then((json) => {
                    if (json.status == 'SUCCESS') {
                        this.reviewers = json.users;
                        if(this.reviewers.length == 1 && !this.formresponse.userreview_id){
                            this.formresponse.userreview_id = this.reviewers[0].id;
                            this.formresponse.review_displayname = this.reviewers[0].displayname;
                        }
                    }
                })
                .catch((error) => {
                    this.$log.error.call(this, error);
                });
        },
        selectSigner() {
            const self = this;
            this.$store.commit("openModal", {
                type: "selector",
                title: this.$t('select-a-signer'),
                selectCallback: function (selection) {

                    self.formresponse.usersignofffrom_id = selection.id;
                    self.formresponse.usersignoff_displayname = selection.displayname;

                    self.$store.commit("closeModal");
                },
                selected: [{
                    id: this.formresponse.usersignofffrom_id
                }],
                data: this.signers,
                captionKey: 'displayname'
            });
        },
        selectObserver() {
            const self = this;
            this.$store.commit("openModal", {
                type: "selector",
                title: this.$t('select-an-observer'),
                selectCallback: function (selection) {
                    self.formresponse.userobserver_id = selection.id;
                    self.formresponse.userobserver_displayname = selection.displayname;
                    self.$store.commit("closeModal");
                },
                selected: [{
                    id: this.formresponse.userobserver_id
                }],
                data: this.observers,
                captionKey: 'displayname'
            });
        },
        selectReviewer() {
            const self = this;
            this.$store.commit("openModal", {
                type: "selector",
                title: this.$t('select-a-reviewer'),
                selectCallback: function (selection) {

                    self.formresponse.userreview_id = selection.id;
                    self.formresponse.userreview_displayname = selection.displayname;

                    self.$store.commit("closeModal");
                },
                selected: [{
                    id: this.formresponse.userreview_id
                }],
                data: this.reviewers,
                captionKey: 'displayname'
            });
        },
        nullPageValues(page) {
            for (let row of page.grid) {
                for (let col of row) {
                    for (let field of col.fields) {
                        field.value = null;
                    }
                }
            }
            return page;
        },
        /*addPage(page) {
            // copy page before nulling values
            const newPage = this.nullPageValues(JSON.parse(JSON.stringify(page)) );
            console.log(newPage);
        },
        removePage(page) {
            console.log(page);
        },*/
        nextPage() {
            if (this.pageNum < this.filteredPages.length) {
                this.pageNum++
            }
        },
        previousPage() {
            if (this.pageNum > 1) {
                this.pageNum--;
            }
        },
        formSubmitFailed() {
            this.$store.commit("openDialog", {
                title: this.$t("oops"),
                content: this.$t("form-save-failed"),
                confirmCallBack: function () {
                }
            });

        },
        formSubmitSuccess() {
            const self = this;
            this.$store.commit("openDialog", {
                title: this.$t("saved"),
                content: this.$t("form-saved"),
                confirmCallBack: function () {
                    self.$router.replace(`/forms`);
                }
            });

        },
        // validateCounts() {
        //     let exceeded = false;
        //     let pages = [];
        //     if (this.formresponse && this.formresponse.formresponse_data && this.formresponse.formresponse_data.pages) {
        //     pages = this.formresponse.formresponse_data.pages;
        //     } else if (this.settings && this.settings.pages) {
        //     pages = this.settings.pages;
        //     }
        //     pages.forEach(page => {
        //     if (page.grid) {
        //         page.grid.forEach(row => {
        //         row.forEach(col => {
        //             col.fields.forEach(field => {
        //             if (field.enableCount && typeof field.countLimit === 'number' && field.countLimit > 0) {
        //                 const value = (field.value || "").toString().trim();
        //                 let count = 0;
        //                 if (field.countMode === 'characters') {
        //                 count = value.length;
        //                 } else if (field.countMode === 'words') {
        //                 count = value.split(/\s+/).filter(word => word).length;
        //                 }
        //                 if (count > field.countLimit) {
        //                 exceeded = true;
        //                 }
        //             }
        //             });
        //         });
        //         });
        //     }
        //     });
        //     return exceeded;
        // },
        validateCounts(payload){
            this.limitexceeded = payload
            return payload
        },
        validateRequiredFields(actionRole = null) {
            let hasRequired = false;
            // actionRole scopes the check to the role performing the current action (submitter/reviewer/signer),
            // so an 'editall'-privileged user isn't blocked by required fields belonging to a later workflow
            // stage that isn't theirs to fill in yet. Falls back to identity role if no action is specified.
            const effectiveRole = actionRole || this.role;
            const pages = this.formresponse?.formresponse_data?.pages || this.settings?.pages || [];

            pages.forEach(page => {
                if (!page.grid) return;

                page.grid.forEach(row => {
                    row.forEach(col => {
                        col.fields.forEach(field => {
                            if (!field.required || field.required == false) return;
                            //if (field.permission?.length == 0) return;
                            if (field.permission.length && !field.permission?.includes(effectiveRole) && effectiveRole !== 'editall') return;

                            const hasValue = field.value !== undefined &&
                                field.value !== null &&
                                !(Array.isArray(field.value) && field.value.length === 0) &&
                                !(typeof field.value === 'string' && field.value.trim() === '');

                            const hasValidData = field.data?.some(item => item?.value > 0) || false;

                            if (!hasValue && !hasValidData) hasRequired = true;
                        });
                    });
                });
            });

            if(
                effectiveRole === 'submitter' &&
                Number(this.formresponse?.workflowstage?.tteventmandatory) == 1 && !this.ttevent_id
                && this.formsubmissioneventismandatory
            )
            {
                return true;
            }

            return hasRequired;
        },
        requiredFieldsCompletedFor(actionRole) {
            return !this.validateRequiredFields(actionRole);
        },
        saveFormResponse(silent = false) {
            if (this.limitexceeded) {
                this.$store.commit("openDialog", {
                    title: this.$t('word/character-count'),
                    content: this.$t('Limit-exceeded!'),
                });
                return;
            }
            this.$store.commit("showBlockingSpinner");

            if (this.formresponse.datetime) {
                this.formresponse.formresponse_dateofresponse = this.$datetime.getTimeStampFromDateTimeField(
                    this.formresponse.datetime
                );
            }

            if(this.ttevent_ids.length) this.formresponse.ttevent_ids = this.ttevent_ids;

            if(this.formresponse.usersignofffrom_id){
                this.formresponse.externaluser_id = null;
            } else {
                this.formresponse.usersignofffrom_id = null;
            }

            this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/save/`, {
                method: 'post',
                data: {
                    formresponse: this.formresponse,
                }
            }).then(json => {
                if (silent) return;
                if (json.status.toLowerCase() === "success") {
                    // form saved
                    //this.$router.replace(`/forms`);

                    this.formSubmitSuccess();
                } else {
                    // something went wrong
                    this.formSubmitFailed();
                }
            }).catch(error => {
                this.$log.error.call(this, error);
                this.formSubmitFailed();
            }).finally(() => {
                this.$store.commit("hideBlockingSpinner");
            })
        },
        unableToOpenFormResponse() {
            const self = this;
            this.$store.commit("openDialog", {
                title: this.$t('oops'),
                content: this.$t('unable-to-open-form'),
                confirmCallBack: function () {
                    self.$router.replace('/forms');
                }
            });
        },
        getReportHTML() {
            this.loadingreportview = true;
            this.loadinghtmlreportview = true;
            this.$cfetch(`${this.$settings.APIBaseURL}/savedreports/getreporthtml`, {
                data: {
                    id: this.formresponse.savedreport.savedreport_id,
                    user_id: this.formresponse.savedreport.student_id,
                }
            })
                .then(json => {
                    if (json.status.toLowerCase() === "success") {
                        this.reportHtml = json.result;
                    }
                    this.loadingreportview = false;
                }).catch(error => {
                    this.$log.error.call(this, error);
                });

            this.$cfetch(`${this.$settings.APIBaseURL}/reporting/htmlreport/individual`, {
                cache: false,
                data: {
                    student_id: this.formresponse.savedreport.student_id,
                    teacher: this.$UserSession.getValue.call(this, 'id'),
                    date_from: this.formresponse.savedreport.inputs.date_from,
                    date_to: this.formresponse.savedreport.inputs.date_to
                }
            })
                .then(json => {
                    if (json.status === "SUCCESS") {
                        this.individualReportHtml = `<div class="alert alert-info">${this.$t('no-data')}</div>`;
                        if (json.html) {
                            this.individualReportHtml = json.html;
                        } else {
                            this.individualReportHtml = `<div class="alert alert-info">${this.$t('no-data')}</div>`;
                        }
                    } else {
                        this.$log.error.call(this, "Could not fetch user report");
                        this.individualReportHtml = `<div class="alert alert-info">${this.$t('no-data')}</div>`;
                    }
                    this.loadinghtmlreportview = false;
                })
                .catch(error => {
                    this.$log.error.call(this, error);
                    this.individualReportHtml = `<div class="alert alert-info">${this.$t('no-data')}</div>`;
                });
        },
        getForm(id) {
            return this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/getform/${id}`)
                .then(json => {/*The response from the server is parsed as JSON using the cfetch method.
				If the response status is "SUCCESS", the method then extracts the form object from the JSON response, and updates the form, form_id and settings properties*/
                    if (json.status == 'SUCCESS') {
                        this.formresponse = {
                            id: null,
                            workflowstage_id: this.$route.params.stageid ? this.$route.params.stageid : null,
                            form_id: json.form.id,
                            user_id: this.$UserSession.getValue.call(this, 'id'),
                            userfrom_id: null,
                            usersubject_id: null,
                            userreview_id: null,
                            usersignofffrom_id: null,
                            externaluser_id: null,
                            datetime: this.$datetime.getDateTimeLocalFieldNowValue(),
                            workbooks: [],
                            workflowstage: {},
                            formresponse_data: json.form.settings
                        }

                        this.formsubmissioneventismandatory = json.formsubmissioneventismandatory
						
                        this.getSubjects();
                        this.getReviewers();
                        this.getSigners();
                        this.getObservers();

                    } else {
                        this.$log.error.call(this, 'Could not open form');
                        this.unableToOpenFormResponse();
                    }
                }).catch(error => {
                    this.$log.error.call(this, error);
                    this.unableToOpenFormResponse();
                });
        },
        getWorkflowstage(id) {
            return this.$cfetch(`${this.$settings.APIBaseURL}/workflows/stages/get/`, {
                method: 'get',
                data: {
                    id: id
                }
            })
                .then(json => {/*The response from the server is parsed as JSON using the cfetch method.
				If the response status is "SUCCESS", the method then extracts the form object from the JSON response, and updates the form, form_id and settings properties*/
                    if (json.status == 'SUCCESS') {
                        this.formresponse.workflowstage = json.result;
                    } else {
                        this.$log.error.call(this, 'Could not open workflowstage');
                        this.unableToOpenFormResponse();
                    }
                }).catch(error => {
                    this.$log.error.call(this, error);
                    this.unableToOpenFormResponse();
                });
        },
        getFormResponse(id) {
            this.$store.commit("showBlockingSpinner");
            this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/load/${id}`)
                .then(json => {
                    this.$store.commit("hideBlockingSpinner");
                    if (json.status.toLowerCase() === "success") {
                        // fix collapsed textareas after first page
                        /*for(const page of json.formresponse.formresponse_data.pages) {
                            page.autosizetextareas = false;
                        }
                        json.formresponse.formresponse_data.pages[0].autosizetextareas = true;*/

                        this.formresponse = json.formresponse;

                        if (this.formresponse.savedreport && this.formresponse.savedreport.student_id && this.formresponse.savedreport.savedreport_id) {
                            this.getReportHTML();
                        }

                        if (this.formresponse.formresponse_dateofresponse) {
                            // Fix the date for the UI
                            this.formresponse.datetime = this.$datetime.getDateTimeFieldValueFromTimestamp(
                                this.formresponse.formresponse_dateofresponse ,
                                true
                            );
                        } else {
                            this.formresponse.datetime = this.$datetime.getDateTimeLocalFieldNowValue();
                        }
                        this.getSubjects();
                        this.getReviewers();
                        this.getSigners();
                        this.getObservers();
                        this.getEvents();
                    } else {
                        this.unableToOpenFormResponse();
                    }
                }).catch(error => {
                    this.$store.commit("hideBlockingSpinner");
                    this.unableToOpenFormResponse();
                    this.$log.error.call(this, error)
                    console.error(error);
                });
        },
        openWorkbooksModal() {
            const self = this
            this.$store.commit("openModal", {
                type: "selector",
                title: this.$t('select-workbooks'),
                selectCallback: function (selection) {
                    const isSelected = self.formresponse.workbooks.find(
                        (workbook, i) => {
                            if (workbook.id === selection.id) {
                                self.$delete(self.formresponse.workbooks, i);
                                return true;
                            }
                        }
                    );
                    if (!isSelected) {
                        self.formresponse.workbooks.push(selection);
                    }
                },
                selected: this.formresponse.workbooks,
                data: this.$config.getValue('workbooks'),
                captionKey: 'title'
            });
        },
        getEvents() {
            this.$cfetch(
                `${this.$settings.APIBaseURL}/timetables/events/studentsignableevents/`,
                {
                    data : {
                        updateattendance: Number(this.formresponse?.workflowstage?.updateattendance),
                        updateabsence: Number(this.formresponse?.workflowstage?.updateabsence),
                    }
                }
            ).then(res => {
                if (res.status === "SUCCESS") {

                    this.ttevents = (res.results || []).map(ttevent => {
                        const fulltitle = `${ttevent.ttsessiontype?.name}${ttevent.title ?  ', ' + ttevent.title : ''}`;

                        const time = this.$datetime.timestampToTime(Number(ttevent.date), false)
                        const date = this.$datetime.getLocaleDateStringFromTimestamp(ttevent.date)
                        const coords =`[${ttevent.ttroom?.name} ${this.$t('at')} ${date}, ${time}]`;
                        ttevent.title = fulltitle+' '+coords;
                        return ttevent;
                    });


                    if (this.ttevents.length === 0) {
                        this.$log.info.call(this, 'There are no events matching the current time window');
                    } else if (this.ttevents.length === 1) {
                        this.ttevent_id = this.ttevents[0].id;
                    }

                } else {
                    if (res.error_message) {
                        this.error = res.error_message;
                    } else {
                        this.error = this.$t("problem-getting-events");
                    }
                }
            }).catch((error) => {
                this.$log.error.call(this, error);
                console.error(error);
            });
        },
        removeWorkbook(selection) {
            const self = this
            self.formresponse.workbooks.find(
                (workbook, i) => {
                    if (workbook.id === selection.id) {
                        self.$delete(self.formresponse.workbooks, i);
                        return true;
                    }
                }
            );
            return false;
        },
        userCanCompletePage(page) {
            var viewAs = this.role;
            return !('permission' in page) || page.permission.length === 0 || page.permission.includes(viewAs) || viewAs == 'editall'
        },
        userCanViewPage(page) {
            return !page.hideifcantcomplete || this.userCanCompletePage(page) || (page.showaftersignoff && this.formresponse && this.formresponse.formresponse_signedoff == '1');
        },
        unsign() {
            this.formresponse.formresponse_signedoff = 0;
            this.saveFormResponse(true);
        },
        unreview() {
            this.formresponse.formresponse_reviewed = 0;
            this.saveFormResponse(true);
        },
        hasNextUpdater(data) {
            this.hasNext = true;
            this.hasNext = data;
            return data;
        },
        // toggleRequestSignoff() {
        //     this.requestSignoffActive = !this.requestSignoffActive;
        //     if (this.requestSignoffActive) {
        //         this.$nextTick(() => {
        //             this.$refs.requestSignoff.scrollIntoView({
        //                 behavior: 'smooth',
        //                 block: 'start'
        //             });
        //         });
        //     }
        // },
        fetchExtUser(payload) {
            if (payload) {
                this.formresponse.externaluser_id = payload.extuser_id;
                this.formresponse.formresponse_completed = 1;
                this.formresponse.usersignofffrom_id = null;
                this.saveFormResponse();
            }
        },
        withdrawFormResponse() {
            this.formresponse.formresponse_completed = 0;
            this.saveFormResponse();
        },
        openDialog(action) {
            var self = this;
            this.$store.commit('openDialog', {
                title: this.$t('are-you-sure'),
                content: this.$t(`${action}-form-warning`),
                cancelBtn: true,
                confirmCallBack: function () {
                    self.handleWorkflow(action)
                }
            })
        },
        handleEventSelector(ids){
            if(ids && ids.length) {
                this.ttevent_id = ids[0];
                this.ttevent_ids = ids;
            }
            return;
        },
        handleWorkflow(action) {
            if (action == 'delete'){
                this.deleteFormResponse()
            } else {
                if (action == 'abandon') this.formresponse.formresponse_abandoned = '1';
                if (action == 'activate') this.formresponse.formresponse_abandoned = '0';

                this.saveFormResponse(true);
            }
        },
        deleteFormResponse() {
			this.$cfetch(`${this.$settings.APIBaseURL}/forms/response/delete`, {
				data: {
					id: this.formresponse.formresponse_id
				}
			})
			.then((res) => {
				if (res.status === "SUCCESS") {
					this.$router.replace(`/forms`);
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
    },
    computed: {

        isSignedOff() {
            return this.formresponse.formresponse_signedoff == '1';
        },
        isObserved() {
            return this.formresponse.formresponse_observed == '1';
        },
        showObserveBtn() {
            return this.$UserSession.getValue('id') == this.formresponse.userobserver_id && !this.isObserved && this.isSignedOff;
        },
        isReviewed() {
            return this.formresponse.formresponse_reviewed == '1';
        },
        /*canChangeSignoffFrom() {
            return this.formresponse.formresponse_signedoff == '0' || this.$UserSession.hasPriv.call(this, "VIEW_ALLFORMS");
        },*/
        filteredPages() {
            const pages = [];
            if (this.formresponse_data) {
                for (let page of this.formresponse_data.pages) {
                    if (this.userCanViewPage(page)) {
                        pages.push(page);
                    }
                }
            }
            return pages;
        },
        showNextPageBtn() {
            return this.formresponse_data && this.formresponse_data.next && this.pageNum < this.filteredPages.length;
        },
        showPreviousPageBtn() {
            return this.formresponse_data && this.formresponse_data.previous && this.pageNum > 1;
        },
        isLastPage() {
            return this.pageNum === this.filteredPages.length;
        },
        /*numPages() {
            if(this.formresponse_data) {
                return this.formresponse_data.pages.length;
            } else {
                return false;
            }
        },*/
        isTeacher() {
            return this.$UserSession.hasPriv.call(this, "MARK_TREATMENTSESSIONS");
        },
        canEdit() {
            return !this.isSignedOff && this.role !== 'observer';
        },
        showSaveDraftBtn() {
            return this.canEdit
        },
        showSubject() {
            return this.formresponse.workflowstage && Number(this.formresponse?.workflowstage.hassubject) == 1
        },
        showReviewer() {
            return (this.role == 'submitter' || this.role == 'editall') && this.formresponse.workflowstage && Number(this.formresponse.workflowstage.requirereview) == 1 && this.formresponse.formresponse_reviewed != '1'
        },
        showObserver() {
            return (this.role == 'submitter' || this.role == 'editall') && this.formresponse.workflowstage && Number(this.formresponse.workflowstage.requireobserver) == 1
        },
        showRequestSignOffBtn() {
            return (this.role == 'submitter' || this.role == 'editall') && this.formresponse.workflowstage && Number(this.formresponse.workflowstage.requiresignoff) == 1;
        },
        showSignOffBtn() {
            return this.formresponse.usersignofffrom_id == this.$UserSession.getValue('id') && this.formresponse.formresponse_completed == '1' && (!this.formresponse.userreview_id || this.formresponse.formresponse_reviewed == '1');
        },
        showMarkAsCompleteBtn() {
            return this.formresponse.usersignofffrom_id == this.$UserSession.getValue('id') && this.formresponse.formresponse_completed == '0' && (!this.formresponse.userreview_id || this.formresponse.formresponse_reviewed == '1');
        },
        showReviewBtn() {
            return this.formresponse.userreview_id == this.$UserSession.getValue('id') && this.formresponse.formresponse_completed == '1';
        },
        showCompleteBtn() {
            return (this.role == 'submitter' || this.role == 'editall') && (!this.formresponse.workflowstage || Number(this.formresponse.workflowstage.requiresignoff) == 0)
        },
        formresponse_id() {
            return this.formresponse ? this.formresponse.formresponse_id : null;
        },
        formresponse_data() {
            return this.formresponse ? this.formresponse.formresponse_data : null;
        },
        awaitingFeedbackFromDisplayName() {
            const me = this.$UserSession.getValue('id');
            const fr = this.formresponse;
            if (fr.formresponse_completed != '1' && fr.user_id != me) {
                return fr.user_displayname;
            } else if (fr.formresponse_completed == '1' && !this.isSignedOff && fr.usersignofffrom_id != me) {
                return fr.usersignoff_displayname;
            }
            return null;
        },
        showUnsignBtn() {
            return this.isSignedOff && (this.formresponse.usersignofffrom_id == this.$UserSession.getValue('id') || this.$UserSession.hasPriv.call(this, "VIEW_ALLFORMS"))
        },
        showUnreviewBtn() {
            return this.isReviewed && (this.formresponse.userreview_id == this.$UserSession.getValue('id') || this.$UserSession.hasPriv.call(this, "VIEW_ALLFORMS"))
        },
        showAbandonBtn() {
            return !this.isSignedOff && this.formresponse.formresponse_abandoned != '1'
                && (
                    [this.formresponse.usersignofffrom_id, this.formresponse.userfrom_id].includes(this.$UserSession.getValue('id'))
                    ||
                    this.$UserSession.hasPriv.call(this, "VIEW_ALLFORMS")
                );
        },
        role() {
            if (this.$UserSession.hasPriv.call(this,'EDIT_ALLFORMS')) {
                return 'editall'
            }
            if (this.$UserSession.getValue('id') == this.formresponse.user_id) {
                return 'submitter';
            }
            if (this.$UserSession.getValue('id') == this.formresponse.userreview_id) {
                return 'reviewer';
            }
            if (this.$UserSession.getValue('id') == this.formresponse.usersignofffrom_id) {
                return 'signer';
            }
            if (this.$UserSession.getValue('id') == this.formresponse.userobserver_id) {
                return 'observer';
            }
            if (this.$UserSession.getValue('id') == this.formresponse.usersubject_id) {
                return 'subject';
            }
            return null;
        },
        canEditLearningOutcomes() {
            return this.formresponse.workflowstage && Number(this.formresponse.workflowstage.caneditlearningoutcomes) == 1
        },
        showWithdrawBtn() {
            return this.formresponse.formresponse_completed == 1
                && !(
                    this.formresponse.formresponse_reviewed == 1 || this.formresponse.formresponse_signedoff == 1
                )
                && (
                    this.$UserSession.hasPriv.call(this, "EDIT_ALLFORMS")
                    || [this.formresponse.usersignofffrom_id, this.formresponse.userfrom_id,this.formresponse.user_id].includes(this.$UserSession.getValue('id'))
                )

        },
        showIncompleteLabel(){
            return this.$UserSession.hasPriv.call(this, "EDIT_ALLFORMS") && this.formresponse.usersignofffrom_id == this.$UserSession.getValue('id');
        },
        currentStatusText() {
            if (this.formresponse.formresponse_abandoned == 1){
                return this.$t('abandoned');
            } else {
                return this.$t('active');
            }
        },
    },
    watch: {
        formresponse: {
            handler() {
                this.updateFormProgress();
            },
            deep: true
        }
    },
    mounted() {
        if (this.$route.params.formresponseid != 'new') {
            this.getFormResponse(this.$route.params.formresponseid)
        } else if (this.$route.params.formid) {
            this.getForm(this.$route.params.formid)
            .then(()=> {
                if (this.$route.params.stageid) {
                    return this.getWorkflowstage(this.$route.params.stageid);
                } else return ;
            })
            .then(() => {
                this.getEvents();
            })
            .catch(error => { 
                console.error(error);
                this.unableToOpenFormResponse();
            });
        } else {
            this.unableToOpenFormResponse();
        }
    }
    
}
</script>
